import { Component, OnInit, OnDestroy } from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router } from '@angular/router';
import {CookieService} from 'ng2-cookies';
import {HostListener} from '@angular/core';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';


@Component({
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css'],
  selector: 'admin-header'
})

export class AdminHeaderComponent implements OnInit, OnDestroy { 
  public LOGO = require("../../../assets/document-write-icon.png");
  autos: Auto[];
  public selectedAuto;
  selectedIndex = 0;
  showAuto = false;
  counter = 0;
  theUser: string;
  searchText:string;
  subscription: Subscription;

  @HostListener('click')
  clickInside() {
    this.showAuto = true;
  }

  @HostListener('document:click')
  clickout() {
    this.showAuto = false;
  }

  constructor(private data: DataService, private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router, private _cookieService:CookieService ){} 

  ngOnInit(){
    this.theUser = this.userSVC.authUser.email;

    this.activatedRoute.queryParams.subscribe(params => {
      this.searchText = params['q'] || "";
    });

    if (this.searchText == "") {
      this.data.changeMessage(this.searchText)
    }

    this.subscription = this.data.currentMessage.subscribe(message => this.searchText = message)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setCookie(key: string, value: string){
    return this._cookieService.set(key, value);
  }
  getCookie(key: string){
    return this._cookieService.get(key);
  }

  logout(){
    if(!confirm("Do you want to Sign Out from Siloq®?")) {
      return;
    }
    let gwt = this.getCookie("gwt");
    this.setCookie("gwt", "");
    this.userSVC.logoutGwt(gwt);
    this.router.navigate(['']);
  }

  tagndoc(){
    this.router.navigate(['admin/tagndoc']);
  }

  search() {
    this.router.navigate(['admin/redirect'], { queryParams: { q : this.searchText, u : 'topic' }});
  }

  searchDefault() {
    if (this.showAuto && this.searchText==="") {
      this.search();
    }
  }

  home() {
    //    this.router.navigate(['admin/redirect'], { queryParams: { u : 'search' }});
    this.router.navigate(['admin/search'], { queryParams: { q : this.searchText }});

  }

  auto() {
    //Use a queue for managing in-flight requests

    var res = this.searchText.trim().split(" ");
    var txt = res[res.length - 1];
    txt = txt.trim()
    var head  = this.searchText.substring(0,this.searchText.indexOf(txt)).trim();

    this.counter++;
    var thisCounter = this.counter;
    //var timeoutId = setTimeout(()=> {
    this.showAuto = false;
    /*
    if (txt.length > 2) {
        this.autos = new Array();
      //TODO: [0] current auto textbox value
      //  let t = new Auto();
      //   this.searchText;
      //   t.Rank = 0;
      //   this.autos = new Array()
      //   this.autos[0] = t;

          this.autoService.auto(txt)
               .subscribe(
                   data => {
                     //       this.autos = this.autos.concat(data); //Bind to view
                   if (this.counter == thisCounter) {
                  this.autos = data; //Bind to view

                  if (this.autos.length > 0) {
                    this.showAuto = true;
                    } else {
                      this.showAuto = false;
                    }

                  var i;
                  for (i = 0; i < this.autos.length; i++) {
                    this.autos[i].Name = head  + " " + this.autos[i].Name;
                  }
              }
              },
              err => {
                console.log(err);
              });
        } else {
     */
                     this.autos = new Array();
                     let t = new Auto();
                     t.Name = this.searchText;
                     t.Rank = 0;
                     this.autos.push(t);
                     //this.showAuto = false;
                     this.showAuto = true;
                     //}
                     //     }, 1000/60);
                     //  clearTimeout(timeoutId);
                   }

  public selectAuto( auto: any, i: number) {
    this.selectedIndex = i;
    this.selectedAuto =  auto;
    this.searchText = this.selectedAuto.Name;
    this.search();
    this.showAuto = false;
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 38:
        this.onUp();
        event.preventDefault();
        break;
      case 40:
        this.onDown()
        event.preventDefault();
        break;
      case 13:
        this.search();
        event.preventDefault();
        break;
    }
    return;
  }

  public onDown() {
    if(this.selectedIndex < this.autos.length - 1)
    {
      this.selectedAuto = this.autos[++this.selectedIndex];
      this.searchText = this.selectedAuto.Name;
    }
  }

  public onUp() {
    if(this.selectedIndex > 0)
    {
      this.selectedAuto = this.autos[--this.selectedIndex];
      this.searchText = this.selectedAuto.Name;
    }
  }
}

export class Auto  {
  public Name: string;
  public Rank: number;
}



// WEBPACK FOOTER //
// ./src/app/admin/adminHeader/admin-header.component.ts